import {
  SIGN_UP_REQUEST,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  GET_LETTER_PLANS_REQUEST,
  GET_LETTER_PLANS_SUCCESS,
  GET_LETTER_PLANS_FAILURE,
} from '../../constants/ActionTypes'
import { replace } from 'react-router-redux';
import * as messages from '../../constants/Messages'
import { UsersApi } from '../api/UsersApi';
import { PlansApi } from '../api/PlansApi';

const signupRequest = () => ({
  type: SIGN_UP_REQUEST,
});

const signupSuccess = () => ({
  type: SIGN_UP_SUCCESS,
});

const signupFailure = (error) => ({
  type: SIGN_UP_FAILURE,
  payload: {
    error: error
  }
});

export const signup = (signupInfo) => {
  return (dispatch) => {
    dispatch(signupRequest());

    UsersApi.signup(signupInfo, dispatch)
      .then(() => {
        dispatch(signupSuccess());
        dispatch(replace(`/executive-list`, { message: messages.WELCOME_MESSAGE }));
      })
      .catch((error) => {
        dispatch(signupFailure(error.response.data));
      });
  };
}

/*** GET /letter-plans ***/
const getLetterPlansRequest = () => ({
  type: GET_LETTER_PLANS_REQUEST,
});

const getLetterPlansSuccess = (plans) => ({
  type: GET_LETTER_PLANS_SUCCESS,
  payload: {
    plans: plans,
  }
});

const getLetterPlansFailure = (error) => ({
  type: GET_LETTER_PLANS_FAILURE,
  payload: {
    error: error
  }
});

export function getLetterPlans(data) {
  return async (dispatch) => {
    dispatch(getLetterPlansRequest());

    PlansApi.getLetterPlans(data, dispatch)
      .then((response) => {
        dispatch(getLetterPlansSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getLetterPlansFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/Signup.js